/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import _ from 'lodash';
import moment from 'moment';
import { fonts, themes } from '../../../../common/themes/themes';
import CustomCard from '../../../../common/components/CustomCard';
import CustomTextField from '../../../../common/components/CustomTextField/CustomTextField';
import CustomAutoComplete from '../../../../common/components/CustomAutoComplete/CustomAutoComplete';
import DropAndSelect from '../../../../common/components/DropAndSelect/DropAndSelect';
import ModalFooter from '../../../../common/Modals/CustomModal/ModalFooter';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import Compdirection from '../../../../common/themes/CompDirection';
import { check_user_permission } from '../../../../common/configs/utils';
import { useAppSelector } from '../../../../infra/hooks';
import { DatePickerInput } from '../../../../components';
import {
  baseDateFormatting,
  convertUtcToDate,
} from '../../../../common/helper';

interface propsType {
  setFormData: (data: any) => void;
  reasons: any;
  letterTypes: any;
  hire_date: string;
}

const OffBoardingFormPresenter: React.FC<propsType> = ({
  setFormData,
  reasons,
  letterTypes,
  hire_date,
}) => {
  const { t } = useTranslation();
  const trans: any = t;
  const [resignationDate, setResignationDate] = useState<any>(null);
  const [lastWorkingDay, setLastWorkingDay] = useState<any>(null);
  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );

  const [remarks, setRemarks] = useState('');
  const [filePath, setFilePath] = useState('');
  const [file, setFile] = useState('');
  const [isWaived, setIsWaived] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [calculatedNoticePeriod, setCalculatedNoticePeriod] = useState('');
  const [noticePeriodDays, setNoticePeriodDays] = useState<any>();
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');
  const [reasonId, setReasonId] = useState();
  const [experienceLetterName, setExperienceLetterName] = useState('');

  const [experienceLetterId, setExperienceLetterId] = useState();
  const [reasonName, setReasonName] = useState('');

  const [relievingLetterId, setRelievingLetterId] = useState();
  const [relievingLetterName, setRelievingLetterName] = useState('');
  const [newattachement, setNewAttachement] = useState(false);
  useEffect(() => {
    if (resignationDate && lastWorkingDay) {
      const diffTime = Math.abs(lastWorkingDay - resignationDate);
      const diffDays: any = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const no_of_days = diffDays + 1;
      setNoticePeriodDays(no_of_days);
      setCalculatedNoticePeriod(`${no_of_days} ${trans('Days')}`);
    }
  }, []);

  useEffect(() => {
    if (resignationDate && lastWorkingDay && isWaived) {
      const _date = moment().format('YYYY-MM-DD');
      setLastWorkingDay(_date);
      setNoticePeriodDays(1);
      setCalculatedNoticePeriod(`${1} ${trans('Day')}`);
    }
  }, [isWaived]);
  const handleSetFormData = () => {
    if (
      noticePeriodDays == '' ||
      relievingLetterName == '' ||
      experienceLetterName == '' ||
      reasonName == ''
    ) {
      toast.error(trans('Please fill the missing fields!'));
    } else {
      setFormData({
        isSubmit: isSubmit,
        resignation_reason: reasonId,
        remarks: remarks,
        notice_date: lastWorkingDay,
        registration_date: resignationDate,
        experience_letter: experienceLetterId,
        revive_letter: relievingLetterId,
        notice_period: noticePeriodDays,
        waive_notice_period: isWaived ? 1 : 0,
        attachment: file,
        newattachement: newattachement,
      });
    }
  };
  const handleResignationDate = (value: any) => {
    setResignationDate(value);


    if (lastWorkingDay && value) {
      const dateObject: any = new Date(value);
      const new_lastWorkingDay: any = new Date(lastWorkingDay);
      const diffTime = Math.abs(new_lastWorkingDay - dateObject);

      const diffDays: any = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      const no_of_days = diffDays + 1;
      setNoticePeriodDays(no_of_days);
      setCalculatedNoticePeriod(`${no_of_days} ${trans('Days')}`);
    }
  };

  const offboardingUpload = (e: any) => {
    const file: any = e.target.files[0];
    setNewAttachement(true);
    if (file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      const image_as_files: any = file;
      setFile(image_as_files);
      setFilePath(image_as_base64);
    } else {
      setIsPDF(true);
      setFilePath('');
      setPDFName(file?.name);
      setFile(file);
    }
  };
  const handleLastWorkingDay = (value: any) => {
    setLastWorkingDay(value);

    if (resignationDate && value) {
      const date_last_working_date: any = new Date(value);

      const new_resignation_date: any = new Date(resignationDate);

      const diffTime = Math.abs(date_last_working_date - new_resignation_date);
      const diffDays: any = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const no_of_days = diffDays + 1;
      setNoticePeriodDays(no_of_days);
      setCalculatedNoticePeriod(`${no_of_days} ${trans('Days')}`);
    }
  };
  const handleReasonForResignation = (reasonName: string) => {
    const getReason = _.filter(reasons, function (reason: any) {
      return reason.reason === reasonName;
    });
    if (getReason.length) {
      const reason_type = getReason[0];
      setReasonId(reason_type.id);
      setReasonName(reasonName);
    }
  };
  const handleExperienceLetter = (letterName: string) => {
    const getLetter = _.filter(letterTypes, function (letter: any) {
      return letter.name === letterName;
    });
    if (getLetter.length) {
      const letter_type = getLetter[0];
      setExperienceLetterId(letter_type.id);
      setExperienceLetterName(letterName);
    }
  };
  const handleRelievingLetter = (letterName: string) => {
    const getLetter = _.filter(letterTypes, function (letter: any) {
      return letter.name === letterName;
    });
    if (getLetter.length) {
      const letter_type = getLetter[0];
      setRelievingLetterId(letter_type.id);
      setRelievingLetterName(letterName);
    }
  };
  return (
    <CustomCard
      cardSize={{ card_title: trans('Off-Boarding') }}
      cardHeight="757px"
      cardWidth="800px"
    >
      <Compdirection>
        <Grid container spacing={4} style={{ marginTop: '0.1px' }}>
          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('Hire Date')}
              value={convertUtcToDate(
                hire_date,
                baseDateFormatting,
                null,
                false,
              )}
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <DatePickerInput
              width="100%"
              label={trans('Date of Resignation')}
              value={resignationDate}
              onChange={(newValue: Date | string) => {
                if (newValue > lastWorkingDay) {
                  toast.error(
                    trans(
                      'Resignation date should be not greater than last working day!',
                    ),
                  );
                } else {
                  handleResignationDate(newValue);
                }
              }}
              disableFuture={true}
            />
          </Grid>
          <Grid item xs={6}>
            <DatePickerInput
              width="100%"
              label={trans('Last Working Day')}
              value={lastWorkingDay}
              onChange={(newValue: Date | string) => {
                if (newValue < resignationDate) {
                  toast.error(
                    trans(
                      'Last working day should not be less than resignation date!',
                    ),
                  );
                } else {
                  handleLastWorkingDay(newValue);
                }
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Reason For Resignation')}
              options={_.map(reasons, (reason: any) => {
                return reason?.reason;
              })}
              value={reasonName}
              onChange={(event: any, newValue: any) => {
                handleReasonForResignation(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('Notice Period')}
              value={calculatedNoticePeriod}
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Experience Letter')}
              options={_.map(letterTypes, (exp: any) => {
                return trans(exp?.name);
              })}
              value={experienceLetterName}
              onChange={(event: any, newValue: any) => {
                handleExperienceLetter(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Relieving Letter')}
              options={_.map(letterTypes, (rel: any) => {
                return trans(rel?.name);
              })}
              value={relievingLetterName}
              onChange={(event: any, newValue: any) => {
                handleRelievingLetter(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('Remarks')}
              placeholder={trans('Write Remarks')}
              value={remarks}
              onChange={(e: any) => setRemarks(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <input
                type={'checkbox'}
                checked={isWaived}
                onClick={(e: any) => {
                  setIsWaived(e.target.checked);
                }}
              />
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.defaultIcon,
                }}
              >
                {trans('Request for waiving of Notice Period')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <DropAndSelect
              upload={offboardingUpload}
              src={filePath}
              isPDF={isPDF}
              pdfName={pdfName}
              onDelete={() => {
                setFilePath('');
                setPDFName('');
                setIsPDF(false);
              }}
            />
          </Grid>
          {check_user_permission(auth_permissions, true, 'add') ? (
            <ModalFooter
              isCancelButton={false}
              onClickSubmit={() => {
                handleSetFormData();
                setIsSubmit(true);
              }}
            />
          ) : (
            <></>
          )}
        </Grid>
      </Compdirection>
    </CustomCard>
  );
};

export default OffBoardingFormPresenter;
